import { jsxs, jsx } from "react/jsx-runtime";
import { IconRenderer, Bleed, Box, Text } from "braid-design-system";
import { Logo } from "./styles/Logo/Logo.mjs";
const palette = {
  brand: "#4c459c"
};
const IconVerifiedSVG = ({ title, titleId, ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 52.84 59.59",
    focusable: "false",
    width: 16,
    height: 16,
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: palette.brand,
          d: "M22.83,43.72a.45.45,0,0,1-.29-.09L12,34.85a1.34,1.34,0,0,1-.48-1V24.5a.3.3,0,0,1,.48-.26l10.85,9L48.4,12,28.72.62a4.56,4.56,0,0,0-4.6,0L2.3,13.21a4.61,4.61,0,0,0-2.3,4V42.39a4.63,4.63,0,0,0,2.3,4L24.12,59a4.61,4.61,0,0,0,4.6,0L50.53,46.38a4.62,4.62,0,0,0,2.31-4V18.91L23.12,43.63A.45.45,0,0,1,22.83,43.72Z"
        }
      )
    ]
  }
);
const IconVerified = ({ title, titleId }) => {
  const a11yProps = Boolean(title) ? { title, titleId, role: "img" } : { "aria-hidden": true };
  return /* @__PURE__ */ jsx(IconRenderer, { children: ({ className }) => /* @__PURE__ */ jsx(IconVerifiedSVG, { className, ...a11yProps }) });
};
const verticalPadding = "xxsmall";
const BadgeVerified = ({
  children,
  bleedY = false
}) => {
  const content = /* @__PURE__ */ jsx(Box, { component: "span", display: "flex", cursor: "default", children: /* @__PURE__ */ jsx(
    Box,
    {
      component: "span",
      background: "promoteLight",
      paddingY: verticalPadding,
      paddingX: "xsmall",
      borderRadius: "standard",
      overflow: "hidden",
      children: /* @__PURE__ */ jsxs(Text, { size: "xsmall", weight: "medium", maxLines: 1, children: [
        /* @__PURE__ */ jsx(IconRenderer, { children: ({ className }) => /* @__PURE__ */ jsxs(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "4 2 53 63",
            focusable: "false",
            fill: "currentColor",
            className,
            children: [
              /* @__PURE__ */ jsx(
                "path",
                {
                  fill: "none",
                  d: "M30.42,0a8.69,8.69,0,0,0-4.31,1.15L4.3,13.74A8.65,8.65,0,0,0,0,21.2V46.38a8.63,8.63,0,0,0,4.3,7.45L26.11,66.42a8.57,8.57,0,0,0,8.61,0L56.53,53.83a8.63,8.63,0,0,0,4.3-7.45V21.2a8.65,8.65,0,0,0-4.3-7.46L34.72,1.15A8.68,8.68,0,0,0,30.42,0Z"
                }
              ),
              /* @__PURE__ */ jsx("path", { d: "M26.83,47.71a.38.38,0,0,1-.29-.09L16,38.85a1.38,1.38,0,0,1-.47-1V28.5a.3.3,0,0,1,.48-.26l10.85,9L52.4,16,32.72,4.61a4.63,4.63,0,0,0-4.61,0L6.3,17.21a4.59,4.59,0,0,0-2.3,4V46.38a4.59,4.59,0,0,0,2.3,4L28.11,63a4.63,4.63,0,0,0,4.61,0l21.81-12.6a4.59,4.59,0,0,0,2.3-4V22.9L27.11,47.62A.37.37,0,0,1,26.83,47.71Z" })
            ]
          }
        ) }),
        " ",
        children
      ] })
    }
  ) });
  return bleedY ? /* @__PURE__ */ jsx(Bleed, { component: "span", vertical: verticalPadding, children: content }) : content;
};
BadgeVerified.__isBadge__ = true;
export {
  BadgeVerified,
  IconVerified,
  Logo,
  palette
};
